/**
 * 平台设置相关的接口
 */

import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
const shareUrl = process.env.VUE_APP_FILE_API

export function getPlatformFormKeyApi(params) {
  return request({
    url: baseUrl + `/workbench/gen-form-key`,
    method: 'get',
    params
  })
}

/**
 * 获取设备IP地址
 * @returns
 */
export function getDeviceIPApi() {
  return request({
    url: `${shareUrl}/commons/ip`,
    method: 'get'
  })
}
